<script lang="ts">
  import { postUsers } from "$lib/services/store";
  import { Select, Label } from "flowbite-svelte";
  import { createEventDispatcher } from "svelte";
  import type { PostUser, BlockProps } from "@/src/types/components/WriterMeta";

  let postusers: PostUser[] = [];

  export let props: BlockProps | null = null;

  const dispatch = createEventDispatcher();

  $: postusers = Array.isArray($postUsers) ? $postUsers : [];

  let selectedWriterId = props?.writerId;

  function handleWriterChange() {
    props.writerId = selectedWriterId;
  }
</script>

<Label for="writer">Choose writer</Label>
<Select id="writer" bind:value={selectedWriterId} on:change={handleWriterChange}>
  <option value="">None</option>
  {#if postusers.length > 0}
    {#each postusers as user (user.id)}
      <option value={user.id}>{user.full_name}</option>
    {/each}
  {/if}
</Select>
